import { CalendarMode, Row } from "PFApp/booking/types";
import DropdownButton from "PFComponents/dropdown/dropdown_button";
import { Icon } from "PFComponents/icon";
import { IconName } from "PFTheme/graphics/icons";
import React, { useMemo, useState } from "react";

import { useBookingsOverviewContext } from "../../context/bookings_overview_context";
import { RowMenuDisplayElement } from "./row_menu_display_element";
import { ShowAllBookingsAction, useRowMenuShowAllBookings } from "./row_menu_show_all_bookings";
import { useRowMenuShowInTabOption } from "./row_menu_show_in_tab";
import { useRowMenuSelectAllBookings } from "./use_row_menu_select_all_bookings";

interface RowMenuProps {
  row: Row;
  showAllBookingsAction: ShowAllBookingsAction;
  expanded: boolean;
  setExpanded: (expanded: boolean) => void;
}

export type RowMenuItem = {
  id: string;
  label: string;
  icon?: IconName;
  item: VoidFunction;
  disabled?: boolean;
  isLoading?: boolean;
};

export const RowMenu = ({ row, showAllBookingsAction, expanded, setExpanded }: RowMenuProps) => {
  const [isRowMenuOpened, setIsRowMenuOpened] = useState(false);
  const { calendarMode } = useBookingsOverviewContext();
  const showInTabOption = useRowMenuShowInTabOption({ row });
  const showAllBookings = useRowMenuShowAllBookings({ row, showAllBookingsAction });
  const { selectAllBookings, isSelectAllBookingsEnabled } = useRowMenuSelectAllBookings({
    row,
    expanded,
    setExpanded,
    isRowMenuOpened
  });
  const rowMenuShowAllBookings = calendarMode === CalendarMode.Projects ? [showAllBookings] : [];
  const rowMenuSelectAllBookings = isSelectAllBookingsEnabled ? [selectAllBookings] : [];

  const options = useMemo(
    () =>
      [showInTabOption, ...rowMenuShowAllBookings, ...rowMenuSelectAllBookings].map(
        ({ id, label, icon, item, disabled, isLoading }) => ({
          id,
          item,
          displayElement: <RowMenuDisplayElement icon={icon} label={label} isLoading={isLoading} />,
          disabled
        })
      ),
    [showInTabOption, showAllBookings, calendarMode, isRowMenuOpened]
  );

  return (
    <DropdownButton
      buttonKind="blank"
      options={options}
      handleChange={(fn) => fn?.()}
      handleClick={(e, isOpened) => setIsRowMenuOpened(isOpened)}
      handleClose={() => setIsRowMenuOpened(false)}
      dropDownStyle={{ maxWidth: 300 }}
      buttonStyle={{ alignItems: "flex-start" }}
    >
      <Icon name="menu-vertical" color="paletteBlue0" />
    </DropdownButton>
  );
};
